import useUser from '@alltrails/context/hooks/useUser';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';

// Resolves which tier a paid-feature badge should display for the current user.
// Peak users see Peak badging on every paid feature; everyone else sees the
// feature's own tier.
const usePaidFeatureBadgeTier = (featureTier: PurchaseTier): PurchaseTier => {
  const user = useUser();
  return user?.subscriptionTier === 'peak' ? 'peak' : featureTier;
};

export default usePaidFeatureBadgeTier;
